import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../swof/api";
import { AdminShell } from "./ProtectedRoute";

const knopStijl = {
  fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase",
  color: "var(--gold)", border: "1px solid rgba(201,169,97,0.4)", padding: "10px 16px",
  background: "transparent", cursor: "pointer",
};

const wegStijl = {
  fontFamily: "var(--mono)", fontSize: 9, letterSpacing: "0.16em", textTransform: "uppercase",
  color: "#e8b0a4", border: "1px solid rgba(201,80,60,0.4)", padding: "8px 12px",
  background: "transparent", cursor: "pointer",
};

export default function InschrijvingenPage() {
  const [data, setData] = useState(null);
  const [fout, setFout] = useState("");
  const [bezig, setBezig] = useState(false);

  const laad = () => api.get("/admin/inschrijvingen").then(({ data }) => setData(data));

  useEffect(() => {
    document.body.classList.add("swof");
    laad();
    return () => document.body.classList.remove("swof");
  }, []);

  const download = async () => {
    setFout("");
    try {
      const res = await api.get("/admin/inschrijvingen.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `inschrijvingen-${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { setFout(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };

  const verwijder = async (i) => {
    if (!window.confirm(`${i.email} verwijderen uit de lijst?`)) return;
    setFout("");
    setBezig(true);
    try {
      await api.delete(`/admin/inschrijvingen/${i.id}`);
      await laad();
    } catch (e) { setFout(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBezig(false); }
  };

  return (
    <AdminShell title="Inschrijvingen" actions={
      <button onClick={download} disabled={!data || data.aantal === 0}
        data-testid="inschrijvingen-download" style={knopStijl}>Download CSV</button>
    }>
      <h1 style={{
        fontFamily: "var(--serif)", fontSize: "clamp(30px, 3.6vw, 46px)", fontWeight: 400,
        margin: "0 0 12px", letterSpacing: "-0.02em",
      }}>Blijf op de hoogte</h1>
      <p style={{ fontFamily: "var(--sans)", fontSize: 14, opacity: 0.65, margin: "0 0 32px", maxWidth: "64ch" }}>
        Bezoekers die op de site hun e-mailadres achterlaten bij "Blijf op de hoogte" komen hier
        terecht. Download de lijst als CSV om hem in Excel of een nieuwsbriefprogramma te gebruiken.
      </p>

      {fout && (
        <div data-testid="inschrijvingen-fout" style={{
          marginBottom: 20, padding: "12px 14px", border: "1px solid rgba(201,80,60,0.5)",
          background: "rgba(201,80,60,0.08)", fontFamily: "var(--sans)", fontSize: 13, color: "#e8b0a4",
        }}>{fout}</div>
      )}

      {!data ? (
        <div data-testid="inschrijvingen-laden" style={{ opacity: 0.5 }}>Laden…</div>
      ) : (
        <>
          <div className="eyebrow" data-testid="inschrijvingen-aantal" style={{ fontSize: 10, color: "var(--gold)", marginBottom: 14 }}>
            {data.aantal} {data.aantal === 1 ? "inschrijving" : "inschrijvingen"}
          </div>
          {data.aantal === 0 ? (
            <p data-testid="inschrijvingen-leeg" style={{ fontFamily: "var(--sans)", fontSize: 14, opacity: 0.6 }}>
              Nog geen inschrijvingen.
            </p>
          ) : (
            <ul data-testid="inschrijvingen-lijst" style={{
              listStyle: "none", padding: 0, margin: 0, borderTop: "1px solid var(--line)",
            }}>
              {data.inschrijvingen.map((i) => (
                <li key={i.id} data-testid={`inschrijving-${i.id}`} style={{
                  display: "flex", flexWrap: "wrap", gap: 14, alignItems: "center",
                  justifyContent: "space-between", padding: "14px 8px",
                  borderBottom: "1px solid var(--line)",
                }}>
                  <span style={{ fontFamily: "var(--serif)", fontSize: 17, flex: "1 1 240px", wordBreak: "break-all" }}>{i.email}</span>
                  <span style={{ fontFamily: "var(--mono)", fontSize: 10, opacity: 0.5 }}>
                    {i.aangemeld_op ? new Date(i.aangemeld_op).toLocaleString("nl-NL", { dateStyle: "medium", timeStyle: "short" }) : "—"}
                  </span>
                  <span className="eyebrow" style={{ fontSize: 9, color: "rgba(243,234,215,0.45)" }}>{i.bron || "site"}</span>
                  <button onClick={() => verwijder(i)} disabled={bezig}
                    data-testid={`inschrijving-weg-${i.id}`} style={wegStijl}>Weg</button>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </AdminShell>
  );
}
